var _rect, _rect2, _rect3, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancerCareBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19491_32963)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19491_32963)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19491_32963",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 333,
    height: 133
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 333,
    height: 133,
    rx: 11,
    fill: "#E9F7EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 332,
    height: 132,
    rx: 10.5,
    stroke: "url(#paint1_linear_19491_32963)",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19491_32963)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 37.5,
    r: 74.5,
    fill: "#714FFF",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 37.5,
    r: 64.4,
    stroke: "url(#paint2_linear_19491_32963)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9 37.5C95.9 69.7542 69.9765 95.9 38 95.9C6.02352 95.9 -19.9 69.7542 -19.9 37.5C-19.9 5.24576 6.02352 -20.9 38 -20.9C69.9765 -20.9 95.9 5.24576 95.9 37.5Z",
    stroke: "url(#paint3_linear_19491_32963)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9 37.5C86.9 66.4406 63.6627 89.9 35 89.9C6.33732 89.9 -16.9 66.4406 -16.9 37.5C-16.9 8.55938 6.33732 -14.9 35 -14.9C63.6627 -14.9 86.9 8.55938 86.9 37.5Z",
    stroke: "url(#paint4_linear_19491_32963)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9 37.5C76.9 62.5748 56.7965 82.9 32 82.9C7.20345 82.9 -12.9 62.5748 -12.9 37.5C-12.9 12.4252 7.20345 -7.9 32 -7.9C56.7965 -7.9 76.9 12.4252 76.9 37.5Z",
    stroke: "url(#paint5_linear_19491_32963)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9 37.5C66.9 58.7065 49.4851 75.9 28 75.9C6.5149 75.9 -10.9 58.7065 -10.9 37.5C-10.9 16.2935 6.5149 -0.9 28 -0.9C49.4851 -0.9 66.9 16.2935 66.9 37.5Z",
    stroke: "url(#paint6_linear_19491_32963)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9 37.5C56.9 55.3955 42.6164 69.9 25 69.9C7.38357 69.9 -6.9 55.3955 -6.9 37.5C-6.9 19.6045 7.38357 5.1 25 5.1C42.6164 5.1 56.9 19.6045 56.9 37.5Z",
    stroke: "url(#paint7_linear_19491_32963)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.487 8.98338C261.67 13.6066 257.258 19.6372 254.672 26.3755C244.553 18.2502 230.596 14.8585 216.85 18.4446C194.405 24.3006 181.024 46.546 186.964 68.1311C189.997 79.1514 197.479 87.8685 207.064 92.9825L285.302 137.678L326.597 66.9264",
    stroke: "#6544C6",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.028 12.5344L288.766 25.3868",
    stroke: "#6544C6",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.798 -5.02221L319.997 42.9436",
    stroke: "#6544C6",
    strokeWidth: 18,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19491_32963",
    x1: 15,
    y1: 16.8913,
    x2: 356.592,
    y2: 103.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EEFF",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19491_32963",
    x1: 1,
    y1: 4.325,
    x2: 284.55,
    y2: 204.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19491_32963",
    x1: 98.0956,
    y1: 75.4412,
    x2: 8.61764,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#714FFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19491_32963",
    x1: 88.8922,
    y1: 71.9118,
    x2: 8.22211,
    y2: 37.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#714FFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19491_32963",
    x1: 80.6274,
    y1: 68.3823,
    x2: 8.28118,
    y2: 37.9976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#714FFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19491_32963",
    x1: 71.4853,
    y1: 64.2647,
    x2: 8.85018,
    y2: 37.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#714FFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19491_32963",
    x1: 62.2206,
    y1: 60.1471,
    x2: 8.33234,
    y2: 37.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#714FFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19491_32963",
    x1: 53.0784,
    y1: 56.6176,
    x2: 8.47874,
    y2: 37.9971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#714FFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19491_32963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerCareBg);
export default __webpack_public_path__ + "static/media/Cancer-Care-Bg.a57f7576a258b5b7853558aeef179907.svg";
export { ForwardRef as ReactComponent };